"use strict";

function _typeof(a) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (a) {
    return typeof a;
  } : function (a) {
    return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, _typeof(a);
}

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = ReactSearchAutocomplete, exports.MAX_RESULTS = exports.DEFAULT_INPUT_DEBOUNCE = void 0;

var _templateObject,
    _react = _interopRequireWildcard(require("react")),
    _propTypes = _interopRequireDefault(require("prop-types")),
    _fuse = _interopRequireDefault(require("fuse.js")),
    _config = require("../config/config"),
    _Results = _interopRequireDefault(require("./Results")),
    _SearchInput = _interopRequireDefault(require("./SearchInput")),
    _styledComponents = _interopRequireWildcard(require("styled-components")),
    _utils = require("../utils/utils");

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

function _getRequireWildcardCache() {
  if ("function" != typeof WeakMap) return null;
  var a = new WeakMap();
  return _getRequireWildcardCache = function _getRequireWildcardCache() {
    return a;
  }, a;
}

function _interopRequireWildcard(a) {
  if (a && a.__esModule) return a;
  if (null === a || "object" !== _typeof(a) && "function" != typeof a) return {
    default: a
  };

  var b = _getRequireWildcardCache();

  if (b && b.has(a)) return b.get(a);
  var c = {},
      d = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var e in a) {
    if (Object.prototype.hasOwnProperty.call(a, e)) {
      var f = d ? Object.getOwnPropertyDescriptor(a, e) : null;
      f && (f.get || f.set) ? Object.defineProperty(c, e, f) : c[e] = a[e];
    }
  }

  return c.default = a, b && b.set(a, c), c;
}

function _taggedTemplateLiteral(a, b) {
  return b || (b = a.slice(0)), Object.freeze(Object.defineProperties(a, {
    raw: {
      value: Object.freeze(b)
    }
  }));
}

function _slicedToArray(a, b) {
  return _arrayWithHoles(a) || _iterableToArrayLimit(a, b) || _unsupportedIterableToArray(a, b) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(a, b) {
  if (a) {
    if ("string" == typeof a) return _arrayLikeToArray(a, b);
    var c = Object.prototype.toString.call(a).slice(8, -1);
    return "Object" === c && a.constructor && (c = a.constructor.name), "Map" === c || "Set" === c ? Array.from(a) : "Arguments" === c || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? _arrayLikeToArray(a, b) : void 0;
  }
}

function _arrayLikeToArray(a, b) {
  (null == b || b > a.length) && (b = a.length);

  for (var c = 0, d = Array(b); c < b; c++) {
    d[c] = a[c];
  }

  return d;
}

function _iterableToArrayLimit(a, b) {
  var c = a && ("undefined" != typeof Symbol && a[Symbol.iterator] || a["@@iterator"]);

  if (null != c) {
    var d,
        e,
        f = [],
        g = !0,
        h = !1;

    try {
      for (c = c.call(a); !(g = (d = c.next()).done) && (f.push(d.value), !(b && f.length === b)); g = !0) {
        ;
      }
    } catch (a) {
      h = !0, e = a;
    } finally {
      try {
        g || null == c["return"] || c["return"]();
      } finally {
        if (h) throw e;
      }
    }

    return f;
  }
}

function _arrayWithHoles(a) {
  if (Array.isArray(a)) return a;
}

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      _defineProperty(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function _defineProperty(a, b, c) {
  return b in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}

var DEFAULT_INPUT_DEBOUNCE = 200;
exports.DEFAULT_INPUT_DEBOUNCE = 200;
var MAX_RESULTS = 10;
exports.MAX_RESULTS = 10;

function ReactSearchAutocomplete(a) {
  var b = a.items,
      c = a.fuseOptions,
      d = a.inputDebounce,
      e = a.onSearch,
      f = a.onHover,
      g = a.onSelect,
      h = a.onFocus,
      i = a.onClear,
      j = a.showIcon,
      k = a.showClear,
      l = a.maxResults,
      m = a.placeholder,
      n = a.autoFocus,
      o = a.styling,
      p = a.resultStringKeyName,
      q = a.inputSearchString,
      r = _objectSpread(_objectSpread({}, _config.defaultTheme), o),
      s = _objectSpread(_objectSpread({}, _config.defaultFuseOptions), c),
      t = new _fuse.default(b, s);

  t.setCollection(b);

  var u = (0, _react.useState)(q),
      v = _slicedToArray(u, 2),
      w = v[0],
      x = v[1],
      y = (0, _react.useState)(),
      z = _slicedToArray(y, 2),
      A = z[0],
      B = z[1],
      C = function C(a) {
    var b = [];
    0 < (null === a || void 0 === a ? void 0 : a.length) ? (b = E(a), B(b), e(a, b)) : B(b);
  },
      D = _react.default.useCallback(0 < d ? (0, _utils.debounce)(function (a) {
    return C(a);
  }, d) : function (a) {
    return C(a);
  }, [b]);

  (0, _react.useEffect)(function () {
    x(q);
  }, [q]), (0, _react.useEffect)(function () {
    0 < (null === w || void 0 === w ? void 0 : w.length) && 0 < (null === A || void 0 === A ? void 0 : A.length) && B(E(w));
  }, [b]);

  var E = function E(a) {
    return t.search(a, {
      limit: l
    }).map(function (a) {
      return _objectSpread({}, a.item);
    }).slice(0, l);
  };

  return _react.default.createElement(_styledComponents.ThemeProvider, {
    theme: r
  }, _react.default.createElement(StyledReactSearchAutocomplete, null, _react.default.createElement("div", {
    className: "wrapper"
  }, _react.default.createElement(_SearchInput.default, {
    searchString: w,
    setSearchString: function setSearchString(a) {
      var b = a.target,
          c = b.value;
      x(c), D(c);
    },
    autoFocus: n,
    onBlur: function onBlur() {
      return B([]);
    },
    onFocus: h,
    onClear: i,
    placeholder: m,
    showIcon: j,
    showClear: k
  }), _react.default.createElement(_Results.default, {
    results: A,
    onClick: function onClick(a) {
      B([]), g(a);
    },
    onHover: f,
    setSearchString: x,
    showIcon: j,
    maxResults: l,
    resultStringKeyName: p
  }))));
}

ReactSearchAutocomplete.defaultProps = {
  items: [],
  fuseOptions: _config.defaultFuseOptions,
  onSearch: function onSearch() {},
  onHover: function onHover() {},
  onSelect: function onSelect() {},
  onClear: function onClear() {},
  inputDebounce: 200,
  showIcon: !0,
  showClear: !0,
  maxResults: 10,
  placeholder: "",
  autoFocus: !1,
  onFocus: function onFocus() {},
  styling: {},
  resultStringKeyName: "name",
  inputSearchString: ""
}, ReactSearchAutocomplete.propTypes = {
  items: _propTypes.default.array,
  fuseOptions: _propTypes.default.object,
  inputDebounce: _propTypes.default.number,
  onSearch: _propTypes.default.func,
  onHover: _propTypes.default.func,
  onSelect: _propTypes.default.func,
  onClear: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  showIcon: _propTypes.default.bool,
  showClear: _propTypes.default.bool,
  maxResults: _propTypes.default.number,
  placeholder: _propTypes.default.string,
  autoFocus: _propTypes.default.bool,
  styling: _propTypes.default.object,
  resultStringKeyName: _propTypes.default.string,
  inputSearchString: _propTypes.default.string
};

var StyledReactSearchAutocomplete = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n\n  height: ", ";\n\n  > .wrapper {\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n\n    border: ", ";\n    border-radius: ", ";\n\n    background-color: ", ";\n    color: ", ";\n\n    font-size: ", ";\n    font-family: ", ";\n\n    z-index: ", ";\n\n    &:hover {\n      box-shadow: ", ";\n    }\n    &:active {\n      box-shadow: ", ";\n    }\n    &:focus-within {\n      box-shadow: ", ";\n    }\n  }\n"])), function (a) {
  return parseInt(a.theme.height) + 2 + "px";
}, function (a) {
  return a.theme.border;
}, function (a) {
  return a.theme.borderRadius;
}, function (a) {
  return a.theme.backgroundColor;
}, function (a) {
  return a.theme.color;
}, function (a) {
  return a.theme.fontSize;
}, function (a) {
  return a.theme.fontFamily;
}, function (a) {
  return a.theme.zIndex;
}, function (a) {
  return a.theme.boxShadow;
}, function (a) {
  return a.theme.boxShadow;
}, function (a) {
  return a.theme.boxShadow;
});